import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import UserContext from '../../context/UserContext';

import BlacklistedError from './BlacklistedError';
import ErrorView from './ErrorView';
import GeoIPError from './GeoIPError';
import RtcError from './RtcError';
import TimeoutError from './TimeoutError';
import UnavailableError from './UnavailableError';

function ErrorPage() {
    let location = useLocation();
    const { wording } = useContext(UserContext);

    const { WLOST_700, WLOST_701, WBUTTON_003 } = wording;

    const title = location.state?.title || WLOST_700;
    const message = location.state?.message || WLOST_701;
    const buttonLabel = location.state?.buttonLabel || WBUTTON_003;

    switch (location.state?.code) {
        case 403004:
            return <GeoIPError />;
        case 403005:
            return <BlacklistedError />;
        case 403101:
        case 403102:
            return <RtcError />;
        case 408001:
            return <TimeoutError />;
        case 500401:
            return <UnavailableError />;
        default:
            return <ErrorView title={title} message={message} buttonLabel={buttonLabel} />;
    }
}

export default ErrorPage;